import { ReactElement, useCallback } from 'react';

import { Calendar, CalendarColumn } from './types';
import { format } from 'date-fns';
import { Draw, Canvas } from './Canvas';
import { headerCanvas } from './style.css';
import { DAY_WIDTH, INNER_HEADER_HEIGHT } from './const';
import { monthScale, weekScale } from './calc';

const BG = '#101828';
const FG = '#FFFFFF';

export const CALENDAR_ROW_HEIGHT = Math.floor(INNER_HEADER_HEIGHT / 3);

function renderScale(
  ctx: CanvasRenderingContext2D,
  scale: CalendarColumn[],
  y: number,
  height: number,
  getText: (col: CalendarColumn) => string,
): void {
  for (let i = 0; i < scale.length; i++) {
    const col = scale[i];
    ctx.fillStyle = BG;
    ctx.fillRect(col.left, y, col.width, height);
    ctx.fillStyle = FG;
    ctx.fillText(getText(col), col.left + col.width / 2, y + height / 2);
  }
}

export function Header({
  calendar: { scale, width, resolution, interval },
}: {
  calendar: Calendar;
}): ReactElement | null {
  const draw: Draw = useCallback(
    (ctx) => {
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'center';

      let y = 0;

      switch (resolution) {
        case 'MONTH': {
          ctx.font = '12px Roboto Flex';
          renderScale(ctx, scale, y, INNER_HEADER_HEIGHT, (col) => format(col.start, 'MMM. yyyy'));
          return;
        }
        case 'WEEK': {
          ctx.font = '11px Roboto Flex';
          const height = Math.floor(INNER_HEADER_HEIGHT / 2);
          renderScale(ctx, monthScale(interval, DAY_WIDTH[resolution]), y, height, (col) =>
            format(col.start, 'MMM. yyyy'),
          );
          y += height + 1;
          renderScale(
            ctx,
            weekScale(interval, DAY_WIDTH[resolution]),
            y,
            INNER_HEADER_HEIGHT - y,
            (col) => `w${format(col.start, 'I')}`,
          );
          return;
        }
        case 'DAY': {
          ctx.font = '10px Roboto Flex';
          const height = Math.floor(INNER_HEADER_HEIGHT / 3);
          renderScale(ctx, monthScale(interval, DAY_WIDTH[resolution]), y, height, (col) =>
            format(col.start, 'MMM. yyyy'),
          );
          y += height + 1;
          renderScale(
            ctx,
            weekScale(interval, DAY_WIDTH[resolution]),
            y,
            height,
            (col) => `w${format(col.start, 'I')}`,
          );
          y += height + 1;
          renderScale(ctx, scale, y, INNER_HEADER_HEIGHT - height * 2, (col) => col.start.getDate().toString());
          return;
        }
      }
    },
    [scale, resolution, interval],
  );

  return <Canvas className={headerCanvas} draw={draw} width={width} height={INNER_HEADER_HEIGHT} />;
}
